import { z } from "zod";
import {
  DEAL_CLOSURE_DATE,
  DEAL_AMOUNT,
  INCLUDES_GST,
  PDCS_COLLECTED,
  SALES_PERSON_TYPE,
  DEAL_CLOSED_BY,
  LEAD_TYPE,
  CONTRACT_YEARS,
  PAYMENT_FROM_ENTITY,
  EXPECTED_LAUNCH_DATE,
  AGREEMENT_DOCUMENT,
  INSTALLMENT_YEAR,
  INSTALLMENT_NUMBER,
  EXPECTED_DUE_DATE,
  INSTALLMENT_AMOUNT,
  INSTALLMENT,
  AGREEMENT_DOCUMENT_FILE_NAME,
  MOU_AMOUNT,
  INTEREST_PERCENTAGE,
  INTEREST_AMOUNT,
} from "./consts";

export const schema = z.object({
  [DEAL_CLOSURE_DATE]: z.string().optional(),
  [DEAL_AMOUNT]: z.string().min(1, "This field is required").optional(),
  [INCLUDES_GST]: z.string().optional(),
  [PDCS_COLLECTED]: z.string().min(1, "This field is required"),
  [SALES_PERSON_TYPE]: z.string().min(1, "This field is required"),
  [DEAL_CLOSED_BY]: z.string().min(1, "This field is required"),
  [LEAD_TYPE]: z.string().min(1, "This field is required"),
  [CONTRACT_YEARS]: z.string().min(1, "This field is required"),
  [PAYMENT_FROM_ENTITY]: z.string().min(1, "This field is required"),
  [EXPECTED_LAUNCH_DATE]: z.string().optional(),
  [AGREEMENT_DOCUMENT]: z
    .any()
    .refine((val) => val != null && val !== undefined && val !== "", {
      message: "This field is required",
    }),
  [AGREEMENT_DOCUMENT_FILE_NAME]: z.string().optional(),
});


export const schema2 = z.object({
  // Installments
  [INSTALLMENT]: z
    .object({
      "_id": z.string().optional(),
      [INSTALLMENT_YEAR]: z.string().min(1, "This field is required").optional(),
      [INSTALLMENT_NUMBER]: z.string().min(1, "This field is required").optional(),
      [EXPECTED_DUE_DATE]: z.string().min(1, "This field is required").optional(),
      [INSTALLMENT_AMOUNT]: z.string().min(1, "This field is required").optional(),
      [MOU_AMOUNT]: z.string().min(1, "This field is required").optional(),
      [INTEREST_PERCENTAGE]: z.string().min(1, "This field is required").optional(),
      [INTEREST_AMOUNT]: z.string().min(1, "This field is required").optional(),
    })
    .array(),
});


export type formValues = z.infer<typeof schema>;
export type formValues2 = z.infer<typeof schema2>;
